import { PaymentApi, paymentsApi } from "api";
import { PaziaButton } from "components/atoms";
import { PaziaModal } from "components/molecules";
import { useToaster } from "utils";

interface RegenerateInvoiceModalProps {
  onCloseRequest: (generated?: boolean) => void;
  payment: PaymentApi | null;
}

export const RegenerateInvoiceModal = ({ onCloseRequest, payment }: RegenerateInvoiceModalProps) => {
  const { showError, showSuccess } = useToaster();
  const onRegenerate = async () => {
    if (payment) {
      try {
        await paymentsApi.regenerateInvoice(payment.id);
        showSuccess("Faktura została wygenerowana");
        onCloseRequest(true);
      } catch (error) {
        showError("Nie udało się wygenerować faktury");
        console.error("Error regenerating invoice:", error);
      }
    }
  };
  const onconfiguUpdate = async () => {
    if (payment) {
      try {
        await paymentsApi.createInvoiceConfiguration(payment.id);
        showSuccess("Konfiguracja faktury została zaktualizowana");
        onCloseRequest(true);
      } catch (error) {
        showError("Nie udało się zaktualizować konfiguracji faktury");
        console.error("Error updating invoice configuration:", error);
      }
    }
  };
  return (
    <PaziaModal
      id="edit-session-modal"
      onCloseRequest={onCloseRequest}
      isOpen={payment != null}
      size="xl"
      className="p-4"
    >
      <PaziaButton type="primary" onClick={onconfiguUpdate}>
        Konfig
      </PaziaButton>
      <PaziaButton type="primary" onClick={onRegenerate}>
        Regeneruj
      </PaziaButton>
    </PaziaModal>
  );
};
